/**
 * Blog index: skip featured articles in the paginated list.
 * Loaded from sections/main-blog.liquid as type="module".
 */

const SELECTOR = '[data-section-type="blog"]'

function init(root) {
  if (root.dataset.blogInit) return
  root.dataset.blogInit = 'true'

  const featured = window.BBF?.featuredArticles || []
  const resultsEl = root.querySelector('[data-article-list]')
  root.querySelectorAll('[data-article-item]').forEach((item) => {
    item.classList.remove('image', 'image--animate', 'animation--lazy-load')
  })
  if (!featured.length || !resultsEl) return

  const pageSize = parseInt(root.dataset.paginateBy || '12', 10)
  const totalCount = parseInt(root.dataset.count || '0', 10)
  const totalPages = Math.ceil((totalCount - featured.length) / pageSize)
  const currentPage = Number(new URLSearchParams(window.location.search).get('page') || 1)
  const ignoreIds = new Set(featured.map((item) => item.id))

  Promise.all(
    Array.from({ length: Math.max(totalPages, 1) }, (_, i) =>
      fetch(`${window.location.pathname}?section_id=${root.dataset.sectionId}&page=${i + 1}`).then((res) => res.text())
    )
  ).then((htmlPages) => {
    const snippets = []
    htmlPages.forEach((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html')
      doc.querySelectorAll('[data-article-item]').forEach((item) => {
        if (!ignoreIds.has(Number(item.getAttribute('data-article-id')))) snippets.push(item.outerHTML)
      })
    })
    const start = currentPage === 1 ? 0 : pageSize + (currentPage - 2) * pageSize
    const pageItems = currentPage === 1 ? snippets.slice(0, pageSize) : snippets.slice(start, start + pageSize)
    resultsEl.innerHTML = pageItems.join('')
  })
}

function initAll(scope = document) {
  if (scope.matches?.(SELECTOR)) init(scope)
  scope.querySelectorAll(SELECTOR).forEach(init)
}

initAll()
document.addEventListener('shopify:section:load', (event) => initAll(event.target))
